<template>
  <div class="register-container">
    <!-- 背景图模糊层 -->
    <div class="bg-layer"></div>

    <!-- 申请卡片 -->
    <div class="register-card">
      <!-- 返回登录 -->
      <button type="button" class="back-btn" @click="handleBack">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path
            d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
            fill="currentColor"
          />
        </svg>
        返回登录
      </button>

      <!-- 标题区域 -->
      <div class="register-header">
        <div class="status-badge">
          <span class="badge-dot"></span>
          资格申请 · 人工审核
        </div>
        <h1 class="title">申请权利资格</h1>
        <p class="subtitle">
          提交资料后，我们将在24小时内完成审核并通过邮件通知您
        </p>
      </div>

      <!-- 申请表单 -->
      <form class="register-form" @submit.prevent="handleSubmit">
        <!-- ===== 联系方式 ===== -->
        <div class="section-title">
          <span class="section-line"></span>
          账户信息
          <span class="section-line"></span>
        </div>

        <!-- 邮箱 -->
        <div class="form-group">
          <div class="input-icon">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                fill="currentColor"
              />
            </svg>
          </div>
          <input
            type="email"
            v-model="form.email"
            placeholder="请输入邮箱地址（审核结果将发送至此邮箱）"
            class="form-input"
            autocomplete="off"
          />
        </div>

        <!-- ===== 🆕 邮箱验证码 ===== -->
        <div class="form-group form-group-with-btn">
          <div class="input-icon">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                fill="currentColor"
              />
            </svg>
          </div>
          <input
            type="text"
            v-model="form.verifyCode"
            placeholder="请输入邮箱验证码"
            class="form-input form-input-with-btn"
            maxlength="6"
            autocomplete="off"
          />
          <button
            type="button"
            class="send-code-btn"
            @click="handleSendCode"
            :disabled="codeCooldown > 0 || !isEmailValid"
          >
            <span>{{ captchaText }}</span>
          </button>
        </div>

        <!-- ===== 🆕 邀请码 ===== -->
        <div class="form-group">
          <div class="input-icon">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 2.18l7 3.12v4.7c0 4.83-3.23 9.36-7 10.7-3.77-1.34-7-5.87-7-10.7V6.3l7-3.12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                fill="currentColor"
              />
            </svg>
          </div>
          <input
            type="text"
            v-model="form.inviteCode"
            placeholder="请输入邀请码"
            class="form-input"
          />
        </div>

        <!-- ===== 基本信息 ===== -->
        <div class="section-title">
          <span class="section-line"></span>
          基本信息
          <span class="section-line"></span>
        </div>

        <div class="form-row">
          <div class="form-group half">
            <div class="input-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <input
              type="text"
              v-model="form.firstName"
              placeholder="请输入您的姓名"
              class="form-input"
            />
          </div>

          <div class="form-group half">
            <div class="input-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <input
              type="text"
              v-model="form.lastName"
              placeholder="请输入您的姓氏"
              class="form-input"
            />
          </div>
        </div>

        <!-- 性别 + 生日 双栏 -->
        <div class="form-row">
          <div class="form-group half">
            <div class="gender-radio-group">
              <el-radio-group v-model="form.gender">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
                <el-radio :label="3">保密</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="form-group half">
            <el-date-picker
              v-model="form.birthday"
              type="date"
              placeholder="请选择出生日期"
              format="yyyy/MM/dd"
              value-format="yyyy/MM/dd"
              class="form-input el-date-picker-custom"
              :picker-options="{
                disabledDate: (time) => time.getTime() > Date.now(),
              }"
            />
          </div>
        </div>

        <!-- ===== 婚姻状况 ===== -->
        <div class="section-title">
          <span class="section-line"></span>
          婚姻状况
          <span class="section-line"></span>
        </div>
        <div class="form-group">
          <div class="marital-radio-group">
            <el-radio-group v-model="form.maritalStatus">
              <el-radio :label="1">未婚</el-radio>
              <el-radio :label="2">已婚</el-radio>
              <el-radio :label="3">离异</el-radio>
              <el-radio :label="4">丧偶</el-radio>
            </el-radio-group>
          </div>
        </div>

        <!-- ===== 联系地址 ===== -->
        <div class="section-title">
          <span class="section-line"></span>
          联系地址
          <span class="section-line"></span>
        </div>
        <div class="form-group">
          <div class="input-icon">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                fill="currentColor"
              />
            </svg>
          </div>
          <input
            type="text"
            v-model="form.address"
            placeholder="请输入联系地址"
            class="form-input"
          />
        </div>

        <!-- ===== 职业信息 ===== -->
        <div class="section-title">
          <span class="section-line"></span>
          职业信息
          <span class="section-line"></span>
        </div>

        <!-- 职业 + 工作单位 -->
        <div class="form-row">
          <div class="form-group half">
            <div class="input-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path
                  d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <input
              type="text"
              v-model="form.workUnit"
              placeholder="请输入工作单位"
              class="form-input"
            />
          </div>

          <div class="form-group half">
            <div class="input-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path
                  d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <input
              type="text"
              v-model="form.workAddress"
              placeholder="请输入您的工作地址"
              class="form-input"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group half">
            <div class="input-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path
                  d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <input
              type="text"
              v-model="form.occupation"
              placeholder="请输入您的职业"
              class="form-input"
            />
          </div>
          <div class="form-group half">
            <div class="input-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path
                  d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <select v-model="form.incomeRange" class="form-input form-select">
              <option value="">请选择年收入范围</option>
              <option value="0-5">5万以下</option>
              <option value="5-10">5万 - 10万</option>
              <option value="10-20">10万 - 20万</option>
              <option value="20-50">20万 - 50万</option>
              <option value="50-100">50万 - 100万</option>
              <option value="100+">100万以上</option>
            </select>
          </div>

          <!-- <div class="form-group half">
            <div class="input-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path
                  d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <input
              type="text"
              v-model="form.incomeDetail"
              placeholder="请输入具体年收入（元，选填）"
              class="form-input"
            />
          </div> -->
        </div>

        <!-- ===== 额外信息 ===== -->
        <div class="section-title">
          <span class="section-line"></span>
          其他信息
          <span class="section-line"></span>
        </div>

        <div class="form-group">
          <div
            class="input-icon"
            style="align-items: flex-start; padding-top: 14px"
          >
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path
                d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"
                fill="currentColor"
              />
            </svg>
          </div>
          <textarea
            v-model="form.remarks"
            placeholder="其他补充说明（选填，如申请理由、特殊需求等）"
            class="form-input form-textarea"
            rows="3"
          ></textarea>
        </div>

        <!-- ===== 提交承诺 ===== -->
        <div class="form-agreement">
          <label class="agreement-check">
            <input type="checkbox" v-model="agreeTerms" />
            <span class="checkmark"></span>
          </label>
          <span class="agreement-text">
            本人承诺以上填写信息真实有效，并同意
            <a href="#" @click.prevent="handleTerms">《用户协议》</a>
            <!-- 与
            <a href="#" @click.prevent="handlePrivacy">《隐私保护政策》</a> -->
          </span>
        </div>

        <!-- 审核提示 -->
        <div class="audit-notice">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              fill="currentColor"
            />
          </svg>
          <span>
            <strong>提交后我们将进行人工审核</strong>，审核结果将在
            <strong>24小时内</strong> 通过邮件通知您，请确保邮箱地址准确无误。
          </span>
        </div>

        <!-- 提交按钮 -->
        <button type="submit" class="register-btn" :disabled="isSubmitting">
          <span v-if="!isSubmitting">提交审核申请</span>
          <span v-else class="submitting">
            <span class="spinner"></span>
            提交中...
          </span>
          <span class="btn-glow"></span>
        </button>
      </form>

      <!-- 底部 -->
      <div class="register-footer">
        <span class="footer-line"></span>
        <p>已有账号？</p>
        <button type="button" class="goto-login" @click="handleBack">
          去登录
          <span class="goto-arrow">→</span>
        </button>
      </div>
    </div>

    <!-- 提交成功弹窗 -->
    <div v-if="showSuccessModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-icon">✅</div>
        <h2>提交成功！</h2>
        <p>
          您的资格申请已收到，我们将在
          <strong>24小时内</strong> 完成审核。<br />
          审核结果将通过邮件发送至：<strong>{{ form.email }}</strong>
        </p>
        <p class="modal-tip">请留意查收邮件，感谢您的申请！</p>
        <button class="modal-btn" @click="closeModal">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterComponent",
  data() {
    return {
      form: {
        email: "",
        inviteCode: "", // 🆕 邀请码
        verifyCode: "", // 🆕 验证码
        firstName: "",
        lastName: "",
        gender: 1,
        birthday: "",
        maritalStatus: 1,
        address: "",
        workUnit: "",
        workAddress: "",
        occupation: "",
        incomeRange: "",
        remarks: "",
      },
      agreeTerms: true,
      isSubmitting: false,
      showSuccessModal: false,
      codeCooldown: 0, // 🆕 验证码倒计时
      codeTimer: null, // 🆕 倒计时定时器

      sendCodeIng: false,
    };
  },
  computed: {
    // 🆕 邮箱是否有效
    isEmailValid() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.form.email);
    },
    captchaText() {
      if (this.sendCodeIng) {
        return "发送中";
      }
      if (this.codeCooldown) {
        return `${this.codeCooldown}s 后重试`;
      }
      return "发送验证码";
    },
  },
  beforeUnmount() {
    // 🆕 组件销毁时清除定时器
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
    }
  },
  methods: {
    // ===== 🆕 发送验证码 =====
    async handleSendCode() {
      // 校验邮箱
      if (!this.isEmailValid) {
        this.$message.warning("请输入有效的邮箱地址");
        return;
      }

      try {
        // 模拟发送验证码请求
        console.log("📧 发送验证码到:", this.form.email);

        if (this.sendCodeIng) {
          return;
        }
        this.sendCodeIng = true;

        // 实际项目中调用 API
        const res = await this.$api.code.sendCode({
          email: this.form.email,
          scene: "signup",
        });
        this.sendCodeIng = false;
        if (res.code == 1) {
          this.$message.error(res.msg);
          return;
        }

        // 开始倒计时
        this.codeCooldown = 300;
        this.codeTimer = setInterval(() => {
          this.codeCooldown--;
          if (this.codeCooldown <= 0) {
            clearInterval(this.codeTimer);
            this.codeTimer = null;
          }
        }, 1000);

        this.$message.success("验证码已发送到您的邮箱，请查收");
      } catch (error) {
        console.error("发送验证码失败:", error);
        // this.$message.error("发送验证码失败，请稍后重试");
      }
    },

    validForm() {
      // ========== 表单校验 ==========
      // 邮箱
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.form.email || !emailRegex.test(this.form.email)) {
        this.$message.warning("请输入有效的邮箱地址");
        return false;
      }

      //邀请码
      if (!this.form.inviteCode || this.form.inviteCode.length < 6) {
        this.$message.warning("请输入6位邀请码");
        return false;
      }

      // 🆕 验证码校验
      if (!this.form.verifyCode || this.form.verifyCode.length < 4) {
        this.$message.warning("请输入4位邮箱验证码");
        return false;
      }

      // 姓名
      if (!this.form.firstName || this.form.firstName.length < 2) {
        this.$message.warning("请输入您的真实姓名（至少2位）");
        return false;
      }

      if (!this.form.lastName || this.form.lastName.length < 2) {
        this.$message.warning("请输入您的真实氏名（至少2位）");
        return false;
      }

      // 性别
      if (!this.form.gender) {
        this.$message.warning("请选择您的性别");
        return false;
      }

      // 生日
      if (!this.form.birthday) {
        this.$message.warning("请选择您的出生日期");
        return false;
      }

      // 婚姻状态
      if (!this.form.maritalStatus) {
        this.$message.warning("请选择您的婚姻状态");
        return false;
      }

      // 地址
      if (!this.form.address) {
        this.$message.warning("请输入您的地址");
        return false;
      }

      // 工作单位
      if (!this.form.workUnit) {
        this.$message.warning("请输入您的工作单位");
        return false;
      }

      // 工作地址
      if (!this.form.workAddress) {
        this.$message.warning("请输入您的工作地址");
        return false;
      }

      // 职业
      if (!this.form.occupation) {
        this.$message.warning("请输入您的职业");
        return false;
      }

      // 收入范围
      if (!this.form.incomeRange) {
        this.$message.warning("请选择您的年收入范围");
        return false;
      }

      // 协议勾选
      if (!this.agreeTerms) {
        this.$message.warning("请先阅读并同意资格审核条款与隐私政策");
        return false;
      }

      return true;
    },

    // ===== 表单提交 =====
    async handleSubmit() {
      // 校验表单
      if (!this.validForm()) {
        return;
      }
      // ========== 提交 ==========
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      try {
        // 模拟 API 请求
        const res = await this.$api.user.signup(this.form);

        console.log("📋 资格申请信息:", {
          ...this.form,
          submitTime: new Date().toLocaleString(),
        });

        //关闭提交状态
        this.isSubmitting = false;

        if (res.code !== 0) {
          this.$message.error(res.msg || "注册失败");
          return;
        }
        // 显示成功弹窗
        this.showSuccessModal = true;

        // 重置表单（可选）
        // this.resetForm();
      } catch (error) {
        console.error("提交失败:", error);
        alert("提交失败，请稍后重试");
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.form = {
        name: "",
        gender: "",
        birthday: "",
        inviteCode: "",
        email: "",
        verifyCode: "",
        idCard: "",
        passport: "",
        occupation: "",
        workUnit: "",
        incomeRange: "",
        incomeDetail: "",
        remarks: "",
      };
      this.agreeTerms = false;
      this.codeCooldown = 0;
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
    },

    closeModal() {
      this.showSuccessModal = false;
      // 可以跳转到登录页或首页
      this.$router.push({ name: "Login" });
    },

    handleBack() {
      this.$router.push({ name: "Login" });
    },

    handleTerms() {
      // console.log("查看资格审核条款");
      // this.$router.push({ name: "Agreement" });
      window.open("/agreement", "_blank");
    },

    handlePrivacy() {
      console.log("查看隐私保护政策");
    },
  },
};
</script>

<style scoped>
/* ===== 容器 ===== */
.register-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px 0;
}

/* ===== 背景图层 ===== */
.bg-layer {
  position: absolute;
  inset: 0;
  background-image: url("@/assets/imgs/dlbj.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1.05);
  z-index: 0;
}

/* ===== 申请卡片 ===== */
.register-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 540px;
  padding: 32px 36px 28px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  max-height: 95vh;
  overflow-y: auto;
}

.register-card::-webkit-scrollbar {
  width: 4px;
}

.register-card::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.register-card::-webkit-scrollbar-thumb {
  background: rgba(0, 180, 255, 0.3);
  border-radius: 4px;
}

.register-card:hover {
  border-color: rgba(100, 200, 255, 0.2);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(0, 150, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* ===== 返回按钮 ===== */
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  transition: all 0.3s ease;
  font-family: inherit;
  margin-bottom: 12px;
}

.back-btn:hover {
  color: #00b4ff;
  transform: translateX(-4px);
}

/* ===== 头部 ===== */
.register-header {
  text-align: center;
  margin-bottom: 24px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 180, 255, 0.15);
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 20px;
  padding: 4px 16px 4px 12px;
  font-size: 12px;
  color: #66ccff;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00ff88;
  animation: pulse-dot 2s infinite;
}

@keyframes pulse-dot {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.8);
  }
}

.title {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  margin: 0 0 4px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 13px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 0.5px;
  margin: 0;
}

/* ===== 表单 ===== */
.register-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ===== 分区标题 ===== */
.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 1px;
  margin: 4px 0 2px;
}

.section-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
}

/* ===== 表单项 ===== */
.form-group {
  position: relative;
  display: flex;
  align-items: center;
}

.form-row {
  display: flex;
  gap: 12px;
}

.form-group.half {
  flex: 1;
  min-width: 0;
}

.input-icon {
  position: absolute;
  left: 14px;
  color: rgba(255, 255, 255, 0.3);
  z-index: 2;
  pointer-events: none;
  transition: color 0.3s;
  display: flex;
  align-items: center;
}

.form-input {
  width: 100%;
  padding: 12px 14px 12px 44px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.form-input:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(0, 150, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(0, 100, 255, 0.1);
}

.form-group:focus-within .input-icon {
  color: #00b4ff;
}

/* Select 样式 */
.form-select {
  appearance: none;
  cursor: pointer;
  padding-right: 36px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M6 8L1 3h10z' fill='rgba(255,255,255,0.3)'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
}

.form-select option {
  background: #1a2332;
  color: #fff;
}

/* 日期输入 */
input[type="date"] {
  color-scheme: dark;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.6);
  cursor: pointer;
}

/* 文本域 */
.form-textarea {
  resize: vertical;
  min-height: 60px;
  padding-top: 12px;
  padding-bottom: 12px;
  line-height: 1.6;
}

.form-textarea::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

/* ===== 🆕 带按钮的表单项 ===== */
.form-group-with-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0;
}

.form-input-with-btn {
  padding-right: 120px;
}

.send-code-btn {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  padding: 7px 14px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  font-family: inherit;
  z-index: 3;
}

.send-code-btn:hover:not(:disabled) {
  transform: translateY(-50%) scale(1.02);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.3);
}

.send-code-btn:disabled {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.4);
  cursor: not-allowed;
  transform: translateY(-50%);
}

/* ===== 协议勾选 ===== */
.form-agreement {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 4px;
}

.agreement-check {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 2px;
}

.agreement-check input {
  display: none;
}

.agreement-check .checkmark {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  transition: all 0.3s ease;
  position: relative;
}

.agreement-check input:checked + .checkmark {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border-color: #00b4ff;
}

.agreement-check input:checked + .checkmark::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.agreement-text {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  line-height: 1.6;
}

.agreement-text a {
  color: #00b4ff;
  text-decoration: none;
  transition: color 0.3s;
}

.agreement-text a:hover {
  color: #66ccff;
  text-decoration: underline;
}

/* ===== 审核提示 ===== */
.audit-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.12);
  border-radius: 10px;
  padding: 12px 14px;
  margin-top: 2px;
}

.audit-notice svg {
  flex-shrink: 0;
  margin-top: 1px;
  color: #00b4ff;
}

.audit-notice span {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  line-height: 1.6;
}

.audit-notice strong {
  color: #66ccff;
  font-weight: 600;
}

/* ===== 提交按钮 ===== */
.register-btn {
  position: relative;
  padding: 15px;
  margin-top: 4px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  letter-spacing: 2px;
  font-family: inherit;
}

.register-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 100, 255, 0.35);
}

.register-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.2);
}

.register-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none !important;
}

.btn-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.6s;
  pointer-events: none;
}

.register-btn:hover:not(:disabled) .btn-glow {
  opacity: 1;
}

/* 提交中状态 */
.submitting {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== 底部 ===== */
.register-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.footer-line {
  display: block;
  width: 40px;
  height: 2px;
  margin: 0 auto 10px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.15),
    transparent
  );
  border-radius: 2px;
}

.register-footer p {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  margin: 0;
}

.goto-login {
  background: transparent;
  border: none;
  color: #00b4ff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
  font-family: inherit;
  position: relative;
}

.goto-login::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #00b4ff, #0066ff);
  transition: width 0.3s ease;
}

.goto-login:hover {
  color: #66ccff;
  transform: translateX(4px);
}

.goto-login:hover::after {
  width: 100%;
}

.goto-arrow {
  display: inline-block;
  transition: transform 0.3s ease;
}

.goto-login:hover .goto-arrow {
  transform: translateX(4px);
}

/* ===== 成功弹窗 ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: linear-gradient(145deg, #1a2a3a, #0f1a26);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px 48px 36px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 40px 80px rgba(0, 0, 0, 0.6);
  animation: slideUp 0.4s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-icon {
  font-size: 56px;
  margin-bottom: 12px;
}

.modal-content h2 {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 12px;
}

.modal-content p {
  color: rgba(255, 255, 255, 0.65);
  font-size: 15px;
  line-height: 1.8;
  margin: 0 0 8px;
}

.modal-content p strong {
  color: #66ccff;
}

.modal-tip {
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px !important;
  margin-top: 4px !important;
}

.modal-btn {
  margin-top: 20px;
  padding: 12px 40px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.3);
}

/* ===== 响应式适配 ===== */
@media (max-width: 520px) {
  .register-card {
    padding: 20px 16px 20px;
    border-radius: 16px;
    margin: 12px;
    max-height: 98vh;
  }

  .title {
    font-size: 22px;
  }

  .subtitle {
    font-size: 12px;
  }

  .form-row {
    flex-direction: column;
    gap: 12px;
  }

  .form-group.half {
    flex: none;
    width: 100%;
  }

  .form-input {
    padding: 11px 12px 11px 40px;
    font-size: 14px;
  }

  .form-input-with-btn {
    padding-right: 100px;
  }

  .send-code-btn {
    font-size: 12px;
    padding: 6px 10px;
    right: 4px;
  }

  .register-btn {
    padding: 13px;
    font-size: 15px;
  }

  .bg-layer {
    filter: blur(8px) brightness(0.6);
    -webkit-filter: blur(8px) brightness(0.6);
  }

  .register-footer {
    flex-direction: column;
    gap: 4px;
  }

  .agreement-text {
    font-size: 12px;
  }

  .section-title {
    font-size: 12px;
  }

  .modal-content {
    padding: 28px 20px 24px;
  }

  .modal-content h2 {
    font-size: 20px;
  }

  .status-badge {
    font-size: 11px;
    padding: 3px 12px 3px 10px;
  }

  .audit-notice {
    padding: 10px 12px;
    font-size: 12px;
  }

  .audit-notice span {
    font-size: 12px;
  }
}

@media (max-width: 380px) {
  .register-card {
    padding: 16px 12px 16px;
  }

  .title {
    font-size: 19px;
  }

  .form-input {
    padding: 10px 10px 10px 36px;
    font-size: 13px;
  }

  .form-input-with-btn {
    padding-right: 90px;
  }

  .send-code-btn {
    font-size: 11px;
    padding: 5px 8px;
  }

  .input-icon svg {
    width: 17px;
    height: 17px;
  }

  .input-icon {
    left: 11px;
  }
}

/* Element DatePicker 自定义样式 */
.el-date-picker-custom {
  flex: 1;
  padding: 0px 14px 0px 44px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
}

.el-date-picker-custom:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(0, 150, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(0, 100, 255, 0.1);
}

.el-date-picker-custom::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.el-date-picker-custom >>> .el-input__inner {
  background: transparent;
  border: none;
  color: #fff;
  height: 45px;
}

.el-date-picker-custom >>> .el-input__suffix {
  color: rgba(255, 255, 255, 0.3);
}

/* 性别单选框样式 */
.gender-radio-group {
  flex: 1;
  display: flex;
  gap: 16px;
  /* padding-left: 44px; */
  align-items: center;
  height: 45px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 0 14px;
}

.gender-radio-group >>> .el-radio {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.gender-radio-group >>> .el-radio__input.is-checked + .el-radio__label {
  color: #00b4ff;
}

.gender-radio-group >>> .el-radio__inner {
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.06);
}

.gender-radio-group >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #00b4ff;
  background: #00b4ff;
}

/* 婚姻状况单选框样式（复用性别样式） */
.marital-radio-group {
  flex: 1;
  display: flex;
  gap: 16px;
  align-items: center;
  height: 45px;
  padding: 0 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.marital-radio-group >>> .el-radio {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.marital-radio-group >>> .el-radio__input.is-checked + .el-radio__label {
  color: #00b4ff;
}

.marital-radio-group >>> .el-radio__inner {
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.06);
}

.marital-radio-group >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #00b4ff;
  background: #00b4ff;
}
</style>
